///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import OutlinedInput from "../form-controls/OutlinedInput";
import addTitleForTruncatedText from "../../helpers/addTitleForTruncatedText";
import messages from "../../helpers/messages";

const RangeFilter = ({ handleFilter, field, isLaneMatch }) => {
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");
  const { rangeFilters } = useSelector(
    state => state[isLaneMatch ? "laneMatch" : "bidPricing"]
  );
  const range = rangeFilters[field];

  useEffect(() => {
    if (range) {
      setMinValue(range.minValue);
      setMaxValue(range.maxValue);
    }
  }, [setMinValue, setMaxValue, range]);

  return (
    <div
      id="range-filter"
      onMouseUp={e => e.stopPropagation()}
      className="mt-2"
    >
      <OutlinedInput
        className="truncate"
        type="number"
        data-testid="minValue"
        value={minValue}
        max={maxValue}
        onChange={({ target }) => setMinValue(target.value)}
        onBlur={({ target }) =>
          parseFloat(target.value) > parseFloat(target.max) && setMinValue("")
        }
        onMouseEnter={e => addTitleForTruncatedText(e.target, minValue)}
        onMouseLeave={e => (e.target.title = "")}
      />
      <span className="font-bold"> {messages.to.defaultMessage} </span>
      <OutlinedInput
        className="truncate"
        type="number"
        data-testid="maxValue"
        value={maxValue}
        min={minValue}
        onChange={({ target }) => setMaxValue(target.value)}
        onBlur={({ target }) =>
          parseFloat(target.value) < parseFloat(target.min) && setMaxValue("")
        }
        onMouseEnter={e => addTitleForTruncatedText(e.target, maxValue)}
        onMouseLeave={e => (e.target.title = "")}
      />
      <button
        className="text-button univers-67-bold-cond font-size-14 uppercase fr ml-8"
        data-testid="ok-button"
        style={{ minWidth: 50 }}
        disabled={minValue === "" || maxValue === ""}
        onClick={() => handleFilter(minValue, maxValue)}
      >
        {messages.ok.defaultMessage}
      </button>
    </div>
  );
};

export default RangeFilter;
